import { icons as selectedThemeIcons } from '@theme'
import { defaultIcons } from './defaultIcons'

const supportedNodeTags = new Set(['circle', 'line', 'path', 'polyline', 'rect'])

export function assertIconDefinition(name, definition) {
  if (!definition || typeof definition !== 'object') {
    throw new TypeError(`Theme icon "${name}" must be an object`)
  }
  if (typeof definition.viewBox !== 'string' || !definition.viewBox.trim()) {
    throw new TypeError(`Theme icon "${name}" requires a viewBox`)
  }
  if (!Array.isArray(definition.nodes) || definition.nodes.length === 0) {
    throw new TypeError(`Theme icon "${name}" requires at least one SVG node`)
  }
  definition.nodes.forEach((node) => {
    if (!supportedNodeTags.has(node?.tag) || !node.attrs || typeof node.attrs !== 'object') {
      throw new TypeError(`Theme icon "${name}" contains an unsupported SVG node`)
    }
  })
  return definition
}

export function createIconResolver(themeIcons = {}, fallbackIcons = defaultIcons) {
  if (!themeIcons || typeof themeIcons !== 'object' || Array.isArray(themeIcons)) {
    throw new TypeError('Theme icons must be an object keyed by semantic icon name')
  }

  return function resolveIcon(name) {
    const definition = themeIcons[name] || fallbackIcons[name]
    if (!definition) throw new Error(`Unknown functional UI icon "${name}"`)
    return assertIconDefinition(name, definition)
  }
}

export const resolveThemeIcon = createIconResolver(selectedThemeIcons || {})
